<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5 7.8125H14.0625M12.5 10.9375H14.0625M6.25 14.0625H14.0625M6.25 17.1875H14.0625M17.1875 7.8125H20.7031C21.3503 7.8125 21.875 8.33717 21.875 8.98438V18.75C21.875 20.0444 20.8257 21.0938 19.5312 21.0938M17.1875 7.8125V18.75C17.1875 20.0444 18.2368 21.0938 19.5312 21.0938M17.1875 7.8125V5.07812C17.1875 4.43092 16.6628 3.90625 16.0156 3.90625H4.29688C3.64967 3.90625 3.125 4.43092 3.125 5.07812V18.75C3.125 20.0444 4.17433 21.0938 5.46875 21.0938H19.5312M6.25 7.8125H9.375V10.9375H6.25V7.8125Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgNews',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
